export default __webpack_public_path__ + "static/media/avatar.d1b3a0e1.png";